<template>
  <!-- New Order Creation -->
  <modal
    v-if="isNewOrderModal"
    :title="$t('OrderCurrent.modal.newOrder')"
    @close-request="clearNewOrderModal();"
    closable
  >
    <div class="mx-2">
      <div class="row">
        <!-- ORDER -->
        <div class="col-12 col-lg-6" id="Order">
          <h4 class="kne-title">{{$t('OrderPending.orderTab.order')}}</h4>
          <div>
            <regular-input
            :value="order.source"
            @input="order.source = $event"
            type="text" :placeholder="$t('OrderPending.orderTab.source')" class="form-group"
            />
          </div>

          <div>
            <label>{{$t('OrderCurrent.datePromis')}}</label>
            <regular-input
              :value="order.datePromis"
              @input="order.datePromis = $event"
              type="date" :placeholder="$t('OrderPending.orderTab.datePromis')" class="form-group"/>
          </div>
          <div>
            <regular-input
            :value="order.numRef"
            @input="order.numRef = $event"
            type="text" :placeholder="$t('OrderPending.orderTab.reference')" class="form-group"/>
          </div>
          <div>
            <regular-textarea
            :value="order.comment"
            @input="order.comment = $event"
            rows="4" :placeholder="$t('OrderPending.orderTab.comment')" class="form-group"/>
          </div>
        </div>

        <!-- CAR INFO -->
        <div class="col-12 col-lg-6" id="vehicle">
          <h4 class="kne-title">{{$t('OrderCurrent.modal.carInfo.vehicle_info')}}</h4>
          <div>
            <regular-input
              :value="VIN"
              @input="VIN = $event"
              type="text" :placeholder="$t('OrderCurrent.modal.carInfo.VIN')"
              class="form-group"
              :class="{'input--missing' : isValidVin === true}"
            />
            <div class="mb-2">
              <button class="btn btn-kne-orange w-100 form-group" :disabled="VIN === ''" @click="validateVIN(VIN)">{{$t('OrderCurrent.modal.carInfo.validate')}}</button>
            </div>
          </div>

          <regular-select
            :value="YEAR"
            @change="YEAR = $event"
            :placeholder="$t('OrderCurrent.modal.carInfo.year')"
            class="border form-group">
            <option value="2023">2023</option>
            <option value="2022">2022</option>
            <option value="2021">2021</option>
            <option value="2020">2020</option>
            <option value="2019">2019</option>
            <option value="2018">2018</option>
            <option value="2017">2017</option>
            <option value="2016">2016</option>
            <option value="2015">2015</option>
            <option value="2014">2014</option>
            <option value="2013">2013</option>
            <option value="2012">2012</option>
            <option value="2011">2011</option>
            <option value="2010">2010</option>
            <option value="2009">2009</option>
            <option value="2008">2008</option>
            <option value="2007">2007</option>
            <option value="2006">2006</option>
            <option value="2005">2005</option>
            <option value="2004">2004</option>
            <option value="2003">2003</option>
            <option value="2002">2002</option>
            <option value="2001">2001</option>
            <option value="2000">2000</option>
            <option value="1999">1999</option>
            <option value="1998">1998</option>
            <option value="1997">1997</option>
            <option value="1996">1996</option>
            <option value="1995">1995</option>
            <option value="1994">1994</option>
            <option value="1993">1993</option>
            <option value="1992">1992</option>
            <option value="1991">1991</option>
            <option value="1990">1990</option>
            <option value="1989">1989</option>
            <option value="1988">1988</option>
            <option value="1987">1987</option>
            <option value="1986">1986</option>
            <option value="1985">1985</option>
            <option value="1984">1984</option>
            <option value="1983">1983</option>
            <option value="1982">1982</option>
            <option value="1981">1981</option>
          </regular-select>

          <!-- Model -->
          <autocomplete
            :search="searchCarMake"
            :disabled="!(YEAR !== '')"
            :default-value="MAKE"
            ref="autocomplete"
            class="form-group"
            :class="{'input--missing' : !(YEAR !== '')}"
            :placeholder="$t('OrderCurrent.modal.carInfo.make')"
            @submit="onSubmitCarMake">
          </autocomplete>

          <!-- Make -->
          <autocomplete
            :search="searchCarModel"
            :disabled="typeof MAKE === 'undefined' || !(YEAR !== '' && MAKE !== '')"
            :default-value="MODEL"
            ref="autocomplete2"
            class="form-group"
            :class="{'input--missing' : typeof MAKE === 'undefined' || !(YEAR !== '' && MAKE !== '')}"
            :placeholder="$t('OrderCurrent.modal.carInfo.model')"
            @keyup="MODEL = $event.target._value"
            @submit="onSubmitCarModel">
          </autocomplete>

          <div class="toggleSwitch" v-if="buttonList">
            <toggle-switch
              ref="toggleSwitch"
              class="border"
              :optionList="buttonList"
              :multiple="false"
              :clickDisabled="!isModelSelected"
              @emitSelectedOption="updateOptionSelect"
              @setOption="updateOption"
            />
            <hover-tool-tip
              v-if="isModelSelected"
              class="mx-2"
              :clickable="false"
              :text="sizeTooltipText"
              :iconColor="sizeTooltipColor"
              top
              left
            />
          </div>

          <div class="mt-4">
            <div class="my-2 kne-title">
              <h4>{{$t('OrderCurrent.modal.carInfo.docOrDate')}}</h4>
            </div>
            <div class="document-date__container" :class="{'document-date__container--mobile' : isScreenSmall}">
              <div class="document-date__item" :class="{'document-date__item--mobile mt-2' : isScreenSmall}">
                <date-pick
                  v-model="order.dateSignataire"
                  :displayFormat="'DD.MM.YYYY'"
                  :hasInputElement="false"
                  :inputAttributes="{readonly: true}"
                  @input="removeOrderDocsUrl()"
                  :disabled="order.docs != ''"
                  class="border ml-0">
                </date-pick>
                <div class="text-center">
                  <button
                    class="btn mt-1 document-date__button-red border"
                    @click="resetDate()"
                    :disabled="order.docs != ''">
                    <i class="fa fa-refresh" aria-hidden="true"></i> {{$t('OrderCurrent.modal.carInfo.date')}}
                  </button>
                  <button class="btn ml-3 mt-1 border"
                  @click="setDateSignataire()" :disabled="order.docs != ''">{{$t('OrderCurrent.modal.carInfo.vehicleReady')}}</button>
                </div>
              </div>

              <div class="document-date__item" :class="{'document-date__item--mobile mt-2' : isScreenSmall}">
                <custom-vue-dropzone
                  ref="myVueDropzone"
                  @dropzoneFile="updateDropzoneFile"
                />
              </div>
            </div>
          </div>

          <div class="m-2 mt-4">
            <button
            class="btn btn-kne-orange w-100 form-group"
            :disabled="order.dateSignataire === '' && order.docs === ''"
            @click="addVehicle()">{{$t('OrderPending.vehicleInfoTab.add_vehicle')}}</button>
          </div>
        </div>
      </div>

      <!-- VEHICLE COUNTER -->
      <div class="card mb-2" :class="{'mx-2' : !isScreenSmall}">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-center">{{$t('General.number')}}</th>
                <th class="text-center">{{$t('OrderPending.vehicleInfoTab.VIN')}}</th>
                <th class="text-center">{{$t('OrderPending.vehicleInfoTab.year')}}</th>
                <th class="text-center">{{$t('OrderPending.vehicleInfoTab.make')}}</th>
                <th class="text-center">{{$t('OrderPending.vehicleInfoTab.model')}}</th>
                <th class="text-center">{{$t('OrderCurrent.modal.size')}}</th>
                <th class="text-center">{{$t('OrderCurrent.modal.documents')}}</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr v-for="(vehicle, index) in vehicles" :key="index + vehicle.vin + vehicle.year">
                <td class="text-center pt-3">{{index + 1}}</td>
                <td class="text-center pt-3">{{vehicle.vin}}</td>
                <td class="text-center pt-3">{{vehicle.year}}</td>
                <td class="text-center pt-3">{{vehicle.make}}</td>
                <td class="text-center pt-3">{{vehicle.model}}</td>
                <td class="text-center pt-3">{{getStringVehicleSize(vehicle.size)}}</td>
                <td class="text-center pt-3" v-if="vehicle.dateSignataire">{{vehicle.dateSignataire}}</td>
                <td class="text-center pt-3" v-if="vehicle.docs"><i class="fa fa-check ml-2"></i></td>
                <td class="text-center"> <button class="btn btn-kne-red icon-size w-100 py-1" @click="onRemoveVehicle(vehicle, index)"><strong>&times;</strong></button> </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>

      <delivery-location-details
        ref="delivLocDetails"
        :order="order"
        :showBilling="true"
        :addressbook="addressbook"
        @sendSelectedEmails="updateSelectedEmails">
      </delivery-location-details>

      <!-- PRICING -->
      <div class="mx-2 mt-4" id="Pricing">
        <h4 class="kne-title">{{$t('OrderCurrent.modal.pricing')}}</h4>

        <div class="mt-3" id="priceSection">
          <span>{{$t('OrderCurrent.modal.regularPrice')}} ($)</span>
          <regular-input
            :value="order.regularPrice"
            @input="calculateCarPrice(order.regularPrice = $event)"
              :placeholder="'0'" class="form-group" min="0"/>

          <span>{{$t('OrderCurrent.modal.discount')}} (%)</span>
          <regular-input
            :value="order.discount"
            @input="calculateCarPrice(order.discount = $event)"
            :placeholder="'0'" class="form-group" min="0"/>

          <span>{{$t('OrderCurrent.modal.surplus')}} (%)</span>
          <regular-input
            :value="order.surplus"
            @input="calculateCarPrice(order.surplus = $event)"
            :placeholder="'0'" class="form-group" min="0"/>

          <span>{{$t('OrderPending.orderTab.price')}} ($)</span>
          <regular-input-number
          :value="order.price"
          :disabled="true"
          :placeholder="'0'" class="form-group"/>

          <span>{{$t('OrderCurrent.modal.estimatedDate')}}</span>
          <regular-input-number
            :value="order.dateExpected"
            @input="order.dateExpected =  $event"
            :placeholder="$t('OrderCurrent.modal.estimatedDate')"
            class="form-group"/>
        </div>
      </div>
      <!-- Pricing END -->
      <div>
        <button 
          v-if="order.transmitterName && order.receiverName && companyUID === 'e58ff614-8449-4c3e-90b8-b42a48c2972b'"
          class="btn btn-kne-orange w-100 form-group"
          @click="validatePricing(order.transmitterPostcode.substr(0, 3) + '-' + order.receiverPostcode.substr(0, 3))">
          {{$t('OrderPending.vehicleInfoTab.validate')}}
        </button>
      </div>

      <!-- PRICE COUNTER -->
      <div class="col-12 card">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>{{$t('General.number')}}</th>
              <th>{{$t('OrderCurrent.modal.regularPrice')}}</th>
              <th>{{$t('OrderCurrent.modal.discount')}}</th>
              <th>{{$t('OrderCurrent.modal.surplus')}}</th>
              <th>{{$t('OrderCurrent.billing')}}</th>
              <th>{{$t('OrderCurrent.modal.estimatedDelay')}}</th>
              <th>{{$t('OrderCurrent.modal.delay')}}</th>
              <th>{{$t('OrderCurrent.modal.vehicles')}}</th>
              <th>{{$t('OrderCurrent.modal.count')}}</th>
            </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr v-for="(vehicle, index) in pricingAndDelay" :key="vehicle.pricing + index">
                <td>{{index}}</td>
                <td>{{vehicle.price}}$</td>
                <td>{{vehicle.discount}}$</td>
                <td>{{vehicle.surplus}}$</td>
                <td>{{vehicle.payerName}}</td>
                <td>{{vehicle.dateExpected}}</td>
                <td>{{vehicle.delay}}</td>
                <td>{{vehicle.makeModelYear}}</td>
                <td>{{vehicle.count}}</td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>

      <div class="col-12 mt-3">
        <button
          class="btn btn-kne-orange w-100 mb-2"
          :disabled="!formCompleted || !sageOneCheck" @click="addOrder()">
          {{$t('OrderPending.submitOrder')}}
        </button>
      </div>

    </div>
  </modal>
</template>

<script>
import { db } from '../../../../firebase'
import Modal from '../../interface-components/Modal.vue'
import RegularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import RegularTextarea from '../../basic-components/regularTextarea.vue'
import RegularInput from '../../basic-components/regularInput.vue'
import RegularInputNumber from '../../basic-components/regularInputNumber.vue'
import RegularSelect from '../../basic-components/regularSelect.vue'

import ToggleSwitch from '../../special-components/Other-components/ToggleSwitch.vue'
import HoverToolTip from '../../basic-components/HoverToolTip.vue'
import DeliveryLocationDetails from '../Other-components/DeliveryLocationDetails.vue'
import CustomVueDropzone from '../Custom-packages/Custom-VueDropzone.vue'

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'

export default {
  name: 'NewOrderModal',

  components: {
    RegularDatalistDriver,
    RegularTextarea,
    RegularInput,
    RegularInputNumber,
    RegularSelect,
    HoverToolTip,
    DeliveryLocationDetails,
    vueDropzone: vue2Dropzone,
    DatePick,
    Modal,
    CustomVueDropzone,
    ToggleSwitch
  },

  created () {
    this.$bindAsArray('makeModels', db.ref('makeModels'))
  },

  data () {
    return {
      VIN: '',
      YEAR: '',
      MAKE: '',
      MODEL: '',
      SIZE: '',
      isValidVin: false,
      vehicles: [],
      transmitterEmailList: [],
      receiverEmailList: [],
      selectedContactEmails: [],
      pricingAndDelay: [],
      sizeTooltipText: '',
      sizeTooltipColor: '',

      buttonList: {
        heavy: {
          id: 4,
          label: this.$t('OrderCurrent.modal.heavy'),
          value: 'Heavy',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'

        },
        medium: {
          id: 3,
          label: this.$t('OrderCurrent.modal.medium'),
          value: 'Medium',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        light: {
          id: 2,
          label: this.$t('OrderCurrent.modal.light'),
          value: 'Light',
          selected: false,
          selectedBgColor: 'rgb(255, 178, 84)'
        },
        noSize: {
          id: 1,
          label: this.$t('OrderCurrent.modal.nosize'),
          value: 'No Size',
          selected: true,
          selectedBgColor: 'rgb(255, 178, 84)'
        }
      },
      isModelSelected: false
    }
  },

  props: {
    isNewOrderModal: Boolean,
    order: Object,
    addressbook: Array
  },

  methods: {
    setSizeTooltipText (isTruthy) {
      if (isTruthy) {
        this.sizeTooltipText = `${this.$t('Vehicle.size_found')} (${this.getStringVehicleSize(this.SIZE)})`
        this.sizeTooltipColor = 'green'
      } else {
        this.sizeTooltipText = this.$t('Vehicle.size_not_found')
        this.sizeTooltipColor = 'red'
      }
    },

    getStringVehicleSize (size) {
      if (size === '') size = 1
      let text = ''
      const keys = Object.keys(this.buttonList)

      text = keys.find(key => this.buttonList[key].id.toString() === size.toString())
      text = this.buttonList[text].label

      return text
    },

    // Button: Add Vehicle
    addVehicle: function () {
      this.vehicles.push({
        vin: this.VIN,
        make: this.MAKE,
        model: this.MODEL,
        year: this.YEAR.toString(),
        size: this.SIZE,
        docs: this.order.docs,
        dateSignataire: this.order.dateSignataire,
        signataire: this.userInfo.name
      })

      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
      this.SIZE = ''
      this.$refs.toggleSwitch.updateOption(this.buttonList.noSize)
      this.removeOrderDocsUrl()
      this.isModelSelected = false
      this.order.dateSignataire = ''
      this.$refs.autocomplete.value = ''
      this.$refs.autocomplete2.value = ''
    },

    onRemoveVehicle (vehicle, index) {
      this.vehicles.splice(index, 1)
    },

    async updateOptionSelect (optionObj) {
      this.updateMakeModelFirebase(optionObj.id)
      this.SIZE = optionObj.id
    },

    updateOption () {
      this.$refs.toggleSwitch.onOptionSelect(this.buttonList.noSize)
    },

    updateMakeModelFirebase (vehicleSizeId) {
      db.ref(`vehicleSize/${this.companyUID}/${this.returnMakeModel}`).set(vehicleSizeId)
    },

    updateDropzoneFile (file) {
      this.order.docs = file
    },

    // Button: Reset date
    // Reset date of dateSignature
    resetDate () {
      this.order.dateSignataire = ''
    },

    // Button: Vehicle ready
    // Set the dateSignature to Today
    setDateSignataire () {
      this.order.dateSignataire = ''
      this.removeOrderDocsUrl()
      this.order.dateSignataire = this.formatDate(Date.now())
    },

    // Custom Input file, functions: VueDropZone file removed
    // Reset order docs, remove file from dropzone. re-enable dropzone
    removeOrderDocsUrl (file, error, xhr) {
      this.$refs.myVueDropzone.removeOrderDocsUrl()
    },

    // Called when searching a car MAKE autocomplete
    searchCarMake (input) {
      if (input.length < 1) { return [] }
      var yearToUse = Math.abs(1981 - this.YEAR)
      var modelList = Object.keys(this.makeModels[yearToUse])
      return modelList.filter(country => {
        return country.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },

    // Used in conjuction with searchCarMake autocomplete
    onSubmitCarMake (result) {
      this.isModelSelected = false
      this.MODEL = ''
      this.MAKE = result
    },

    // Called when searching a car MODEL in autocomplete
    searchCarModel (input) {
      this.isModelSelected = false

      if (input.length < 1) { return [] }
      var yearToUse = Math.abs(1981 - this.YEAR)
      var modelList = Object.keys(this.makeModels[yearToUse][this.MAKE])
      return modelList.filter(country => {
        return country.toLowerCase()
          .startsWith(input.toLowerCase())
      })
    },

    // Used in conjuction with searchCarModel autocomplete
    async onSubmitCarModel (result) {
      this.isModelSelected = true
      this.MODEL = result

      await this.getVehicleSize(this.returnMakeModel)
    },

    async getVehicleSize (makeModel) {
      await db.ref(`vehicleSize/${this.companyUID}/${makeModel}`).once('value').then((snapshot) => {
        this.SIZE = snapshot.val()

        const keys = Object.keys(this.buttonList)
        let selectedSize = keys.find(key => this.buttonList[key].id.toString() === this.SIZE.toString())
        this.$refs.toggleSwitch.onOptionSelect(this.buttonList[selectedSize])
        this.setSizeTooltipText(true)
      }).catch(() => {
        this.SIZE = 1
        this.setSizeTooltipText(false)
        console.log('No vehicle size')
      })
    },

    // Called to Validate a car VIN
    validateVIN: function (vin) {
      // vin test: 1GTR2VE73CZ288102
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/decodevin/' + vin).then(async (response) => {
        if (response.data.error) {
          this.isValidVin = true
        } else {
          this.MAKE = response.data.make
          this.MODEL = response.data.model
          this.isModelSelected = true
          this.YEAR = response.data.year.toString()
          await this.getVehicleSize(this.returnMakeModel)
          this.$refs.autocomplete.value = response.data.make
          this.$refs.autocomplete2.value = response.data.model
        }
      }).catch((error) => console.log(error))
    },

    addOrder () {
      this.order.transpCigle = this.$store.state.userInfo.cigle
      this.order.transpName = this.$store.state.userInfo.name

      this.$refs.delivLocDetails.saveToAddressbook(this.order)

      for (var attr in this.order) {
        if (this.order[attr] === undefined) this.order[attr] = ''
      }

      this.vehicles.forEach((vehicle) => {
        this.order.selectedContactEmails = this.selectedContactEmails
        this.order.vin = vehicle.vin
        this.order.make = vehicle.make
        this.order.model = vehicle.model
        this.order.year = vehicle.year
        this.order.size = vehicle.size
        this.order.docs = vehicle.docs
        this.order.dateSignataire = vehicle.dateSignataire
        this.order.signataire = vehicle.signataire
        db.ref('test/transporter/' + this.companyUID + '/newDeliveries').push().set(this.order).then(() => {
          // ======================== ADD ORDER LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_ORDER', 'date': Date.now(), 'targetName': this.order.payerName})
        }).catch(function (error) {
          console.log(error)
        })
      })

      this.clearNewOrderModal()
    },

    /** Reinitialize data for new order modal */
    clearNewOrderModal () {
      this.clearData()
      // this.clearEmailList()
      this.$emit('closeNewOrderModal')
    },

    // Called on key events when typing a price in the Add New Order modal
    calculateCarPrice (keyEvent) {
      const discountAmount = ((Number(this.order.regularPrice) * Number(this.order.discount)) / 100)
      const surplusAmount = ((Number(this.order.regularPrice) - discountAmount) * Number(this.order.surplus) / 100)
      this.order.price = ((Number(this.order.regularPrice) - discountAmount) + surplusAmount).toFixed(2)

      this.verifyPriceValues()
    },

    /** From @emits 'sendSelectedEmails' @DeliveryLocationDetails */
    updateSelectedEmails (selectedEmails) {
      this.selectedContactEmails = selectedEmails
    },

    validatePricing: function (names) {
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/pad/pricing/e58ff614-8449-4c3e-90b8-b42a48c2972b/' + names).then((response) => {
        this.pricingAndDelay = response.data
      }).catch((error) => console.log(error))
    },

    /** Clear all data for new order modal */
    clearData () {
      this.VIN = ''
      this.YEAR = ''
      this.MAKE = ''
      this.MODEL = ''
      this.isValidVin = false
      this.vehicles = []
      this.selectedContactEmails = []
      this.pricingAndDelay = []
    },

    removeInvalidChars (text) {
      text = text.replace('.', '')
      text = text.replace('$', '')
      text = text.replace('#', '')
      text = text.replace('[', '')
      text = text.replace(']', '')
      text = text.replace('/', '')
      return text
    },

    formatDate (date) {
      var fdate = new Date(date)
      return fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)
    },

    verifyPriceValues () {
      if (this.order.regularPrice <= 0) {
        this.order.regularPrice = 0
      }

      if (this.order.discount <= 0) {
        this.order.discount = 0
      }

      if (this.order.surplus <= 0) {
        this.order.surplus = 0
      }

      if (this.order.price <= 0) {
        this.order.price = 0
      }
    }
  },

  computed: {
    returnMakeModel () {
      const make = this.MAKE.toLowerCase()
      const model = this.MODEL.toLowerCase()
      let makeModel = make.split(' ').join('') + model.split(' ').join('')

      if (makeModel.length <= 0) makeModel = 'NoMakeModel'
      return makeModel
    },

    returnIsModelSelected () {
      return this.isModelSelected
    },

    formCompleted: function () {
      var order = this.order
      return (
        this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCountry !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        ((this.isSageOne && order.price !== '') || !this.isSageOne))
    },

    userInfo () {
      return this.$store.state.userInfo
    },

    uid () {
      return this.$store.state.user.uid
    },

    companyUID () {
      return this.$store.state.authorization.company
    },

    sageOneCheck () {
      return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
    },

    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    }
  }
}

</script>

<style>
  #addOrder, #customView{
    position: relative;
  }
  .toggleSwitch {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .newOrder__container--display {
    display: flex;
    flex-flow: row;
    width: 50%;
  }

  .newOrder__container--display-mobile {
    display: flex;
    flex-flow: column;
    width: 100%;
  }

  .document-date__container {
    display: flex;
    justify-content: space-between;
  }

  .document-date__container--mobile {
    flex-direction: column;
  }

  .document-date__item {
    width: 45%;
  }

  .document-date__item--mobile {
    width: 100%;
  }

  .document-date__button-red {
    background-color: rgb(255, 58, 58);
  }
</style>
